import {Component, OnInit} from '@angular/core';
import {BancosService} from "./bancos.service";
import {BancosModel} from "./bancos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-bancos',
  templateUrl: './bancos.component.html'
})
export class BancosComponent extends Components implements OnInit {

  bancos: BancosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private bancosService: BancosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'financeiro'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    /*this.carregandoTabela = true;
    this.bancosService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.bancos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.bancos);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });*/
    this.getPage(1);
  }

  delete(banco) {
    let bancos = this.bancos;
    let bancosService = this.bancosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarBanco')+banco.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(bancos);
        }

        let index = bancos.indexOf(banco);
        bancos.splice(index, 1);

        bancosService.apagar(banco.id_banco)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.bancos = bancos;
            },
            err => {
              // Revert the view back to its original state
              bancos.splice(index, 0, banco);
              self.bancos = bancos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.bancosService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.bancos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/bancos/bancos.component.ts